import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'components/ui/tabs';
import LoadingState from 'components/shared/LoadingState';
import BlogTypesTab from './BlogTypesTab';
import TemplatesTab from './TemplatesTab';
import RunsTab from './RunsTab';
import { blogPromptsList, getAdminBlogCategories } from '../../../services/api';
import { errMsg } from '../generator/util';

export default function PromptsPage() {
  const [data, setData] = useState(null);
  const [categories, setCategories] = useState([]);

  const reload = useCallback(() => {
    blogPromptsList().then(setData).catch((e) => toast.error(errMsg(e)));
  }, []);

  useEffect(() => {
    reload();
    getAdminBlogCategories().then((r) => setCategories(r.categories || r || [])).catch(() => {});
  }, [reload]);

  if (!data) return <LoadingState message="Loading prompts…" />;

  const onTemplateChanged = (saved, deletedId) => {
    setData((d) => ({
      ...d,
      templates: deletedId ? d.templates.filter((t) => t.id !== deletedId) : d.templates.map((t) => (t.id === saved.id ? saved : t)),
    }));
  };
  const onTypeSaved = (saved) => setData((d) => ({ ...d, blog_types: d.blog_types.map((t) => (t.id === saved.id ? saved : t)) }));

  return (
    <div>
      <h1 className="mb-1 text-token-lg font-semibold">Blog Generator — prompts</h1>
      <p className="mb-4 text-token-base text-muted-foreground">
        Blog types are the blocks you tune per kind of post. Templates are the full prompts (advanced). Nothing needs resetting after a deploy — rows you haven't edited follow the shipped default automatically.
      </p>
      <Tabs defaultValue="types">
        <TabsList>
          <TabsTrigger value="types">Blog types</TabsTrigger>
          <TabsTrigger value="templates">Templates (advanced)</TabsTrigger>
          <TabsTrigger value="runs">Runs</TabsTrigger>
        </TabsList>
        <TabsContent value="types" className="mt-4"><BlogTypesTab types={data.blog_types || []} categories={categories} onSaved={onTypeSaved} /></TabsContent>
        <TabsContent value="templates" className="mt-4"><TemplatesTab data={data} onChanged={onTemplateChanged} reload={reload} /></TabsContent>
        <TabsContent value="runs" className="mt-4"><RunsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
